<h2 mat-dialog-title>Información usuario</h2>
<form [formGroup]="form">
    <mat-dialog-content>
        <div class="form-obs-profile">
            <h4>Tipo de documento</h4>
            <div class="form-item">
                <input matInput type="text" [value]="data.data.documentType" [disabled]="true">
                <mat-checkbox formControlName="isCorrectDocumentType" color="primary">
                    ¿Es correcto el tipo de documento?
                </mat-checkbox>
                <mat-form-field appearance="fill" *ngIf="!form.controls['isCorrectDocumentType']?.value">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="obsDocumentType"></textarea>
                    <mat-error *ngIf="form.controls['obsDocumentType']?.hasError('required')">Campo requerido</mat-error>
                </mat-form-field>
            </div>
            <h4>Número de documento</h4>
            <div class="form-item">
                <input matInput type="text" [value]="data.data.identificationNumber" [disabled]="true">
                <mat-checkbox formControlName="isCorrectDocument" color="primary">
                    ¿El número de identificación esta correcto?
                </mat-checkbox>
                <mat-form-field appearance="fill" *ngIf="!form.controls['isCorrectDocument']?.value">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="obsDocument"></textarea>
                    <mat-error *ngIf="form.controls['obsDocument']?.hasError('required')">Campo requerido</mat-error>
                </mat-form-field>
            </div>
            <h4>Fecha de expedición</h4>
            <div class="form-item">
                <input matInput type="text" [value]="data.data.issueDate" [disabled]="true">
                <mat-checkbox formControlName="isCorrectIssueDate" color="primary">
                    ¿La fecha de expedición esta correcta?
                </mat-checkbox>
                <mat-form-field appearance="fill" *ngIf="!form.controls['isCorrectIssueDate']?.value">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="obsIssueDate"></textarea>
                    <mat-error *ngIf="form.controls['obsIssueDate']?.hasError('required')">Campo requerido</mat-error>
                </mat-form-field>
            </div>
            <h4>Descripción del perfil</h4>
            <div class="form-item">
                <textarea matInput type="text" [value]="data.data.profileDescription" [disabled]="true"></textarea>
                <mat-checkbox formControlName="isCorrectDescription" color="primary">
                    ¿Se entiende a que se dedica la persona?
                </mat-checkbox>
                <mat-form-field appearance="fill" *ngIf="!form.controls['isCorrectDescription']?.value">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="obsDescription"></textarea>
                    <mat-error *ngIf="form.controls['obsDescription']?.hasError('required')">Campo requerido</mat-error>
                </mat-form-field>
            </div>
        </div>
        <h4>Archivos cargados</h4>
        <div formArrayName="filesArray" class="content-file">
            <div *ngFor="let file of filesArray.controls; let i = index" [formGroupName]="i" class="file-card">
                <label>{{ file.get('fileType')?.value }}</label>
                <button mat-button type="button" (click)="openDocument(file.get('idFile')?.value, $event)" class="modal-button">Abrir
                    archivo</button>

                <mat-form-field appearance="fill">
                    <mat-label>Estado</mat-label>
                    <mat-select formControlName="statusFile">
                        <mat-option *ngFor="let status of dataStatus" [value]="status">
                            {{ status.customerStatus }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="file.get('statusFile')?.hasError('required')">Campo requerido</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="file.get('statusFile')?.value.code === rejectedStatus()">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="observation"></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()" class="cancel-button">Cancelar</button>
        <button mat-button (click)="saveData()" [disabled]="!form.valid"
            [ngClass]="{ 'modal-button': form.valid, 'inactive-button': !form.valid}">Guardar</button>
    </div>
</form>